import { render } from "./DownloadButton.vue?vue&type=template&id=615564aa&scoped=true"
import script from "./DownloadButton.vue?vue&type=script&lang=ts"
export * from "./DownloadButton.vue?vue&type=script&lang=ts"

import "./DownloadButton.vue?vue&type=style&index=0&id=615564aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-615564aa"

export default script